import React from "react";
import { subTitle } from "./SubTitle.module.scss";
import { ISubTitleProps } from "./SubTitleProps";

const SubTitle: React.FC<ISubTitleProps> = (props) => {
  return (
    <div
      style={{ color: props.hotelInfoBgColor }}
      className={`${subTitle} ${props.className ? props.className : ""}`}
      id={props.id}
    >
      {props.children}
    </div>
  );
};

export default SubTitle;
